export class GcpDiskRestoreDestination {
    'gcpDisk';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "gcpDisk",
            "baseName": "gcpDisk",
            "type": "GcpDiskTarget",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpDiskRestoreDestination.attributeTypeMap;
    }
    constructor() {
    }
}
